import LegalPage, { H2, P, UL } from "@/components/LegalPage";
import { BRAND } from "@/config/brand";
import { Mail, Clock, MapPin, LifeBuoy } from "lucide-react";

export default function Contact() {
  return (
    <LegalPage eyebrow="Contact" title="Get in touch"
      updated="8 February 2026" testid="contact-page">
      <P>
        We're a small, dedicated team helping people of every age across India take their first
        step into private counselling. Whether you're an adult, a parent booking for a family
        member, a returning client or a counsellor considering joining, we'd love to hear from you.
      </P>

      <H2>Email</H2>
      <div className="flex items-start gap-3 mt-2">
        <Mail className="w-5 h-5 mt-1 flex-shrink-0" style={{ color: "var(--brand)" }} />
        <div>
          <a href={`mailto:${BRAND.supportEmail}`}
             className="font-semibold" style={{ color: "var(--brand)" }}
             data-testid="contact-email-link">
            {BRAND.supportEmail}
          </a>
          <div className="text-sm mt-0.5" style={{ color: "var(--text-secondary)" }}>
            For bookings, refunds, technical help and general enquiries.
          </div>
        </div>
      </div>

      <H2>Response time</H2>
      <div className="flex items-start gap-3 mt-2">
        <Clock className="w-5 h-5 mt-1 flex-shrink-0" style={{ color: "var(--brand)" }} />
        <div className="text-sm" style={{ color: "var(--text-secondary)" }}>
          Monday to Saturday, 10:00 AM – 8:00 PM IST. We aim to reply within one business day.
          For scheduled sessions already booked, you'll receive confirmations and reminders
          automatically over email.
        </div>
      </div>

      <H2>Registered office</H2>
      <div className="flex items-start gap-3 mt-2">
        <MapPin className="w-5 h-5 mt-1 flex-shrink-0" style={{ color: "var(--brand)" }} />
        <div className="text-sm" style={{ color: "var(--text-secondary)" }}>
          Counseltaria™ · India<br />
          Correspondence: please write to <a href={`mailto:${BRAND.supportEmail}`}
             style={{ color: "var(--brand)" }}>{BRAND.supportEmail}</a> for our current
          postal address if you need to send physical correspondence.
        </div>
      </div>

      <H2>What to include when you write to us</H2>
      <UL>
        <li>Your registered email or username (helps us find your account quickly).</li>
        <li>Your booking or transaction reference, if the message relates to a specific session.</li>
        <li>The best time we can reach you if a phone call would help.</li>
      </UL>

      <H2>Urgent help — please read</H2>
      <div className="mt-2 rounded-lg p-3" style={{ background: "rgba(91,117,83,0.08)" }}>
        <div className="flex items-start gap-3">
          <LifeBuoy className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: "var(--brand)" }} />
          <div className="text-sm" style={{ color: "var(--text-secondary)" }}>
            Counseltaria™ is <strong>not an emergency service</strong>. If you or someone you know
            is in immediate danger or experiencing a mental health crisis, please call
            <strong> iCall (9152987821)</strong>, <strong>Vandrevala Foundation (1860-2662-345)</strong>,
            or dial <strong>112</strong>.
          </div>
        </div>
      </div>
    </LegalPage>
  );
}
